/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";

export const exploreActions = {
  FETCH_ALL_TAGS: "FETCH_ALL_TAGS",
  FETCH_ALL_TAGS_SUCCESS: "FETCH_ALL_TAGS_SUCCESS",
  FETCH_ALL_TAGS_ERROR: "FETCH_ALL_TAGS_ERROR",
};

// export const fetchAllTags = (): IAppAction => ({
//   type: exploreActions.FETCH_ALL_TAGS
// });

export const fetchAllTagsSuccess = (payload: any): IAppAction => ({
  type: exploreActions.FETCH_ALL_TAGS_SUCCESS,
  payload
});

export const fetchAllTagsError = (error: Error): IAppAction => ({
  type: exploreActions.FETCH_ALL_TAGS_ERROR,
  error
});
